var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCompletedReminder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#9258E7",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.54 20.53l-2.13-2.13-1.06 1.06 3.18 3.18 6-6-1.06-1.06-4.93 4.95zm6.797-12.72l4.607 3.845-1.28 1.535-4.61-3.843 1.283-1.537zm-10.674 0l1.282 1.536-4.608 3.844-1.28-1.536 4.606-3.844zM18 10a9 9 0 10.002 18.001 9 9 0 00-.002-18zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z",
    fill: "#5D43CF"
  })));
}

export default __webpack_public_path__ + "34cfa2097a6e37041a0d0271f60fe362.svg";
export { SvgCompletedReminder as ReactComponent };